import { Component, Inject, OnDestroy } from '@angular/core';

import { ProductConfig } from 'app/product-designer-config';
import { AdditionalInfoItemConfig
       } from 'collage-designer/collage-designer-config';
import { StageService } from 'collage-designer/stage/stage.service';
import { ProductService } from 'core/product/product.service';
import { Utils } from 'core/utils';
import { AsyncEventEmitterSubscriber
       } from 'core/utils/async-event-emitter';
import { TemplateConfig } from '../collage-designer-config';
import { DesignStepService } from '../design-step/design-step.service';
import { AdditionalInfoItemInterface
       } from './additional-info-item-interface';

interface OverlayImage {
  advent_landscape: string;
  advent_portrait: string;
  ramadan_landscape: string;
  ramadan_portrait: string;
}

@Component({
    selector: 'advent-calendar-overlay',
    template: ``,
    styleUrls: ['./advent-calendar-overlay.component.scss'],
    standalone: false
})
export class AdventCalendarOverlayComponent
    implements AdditionalInfoItemInterface, OnDestroy
{
  private static readonly OVERLAY_IMAGE: OverlayImage = {
    'advent_landscape': Utils.url(
            './assets/img/additional-info-item-components/' +
            'advent-calendar-overlay/raster-advent-landscape.svg'),
    'advent_portrait': Utils.url(
            './assets/img/additional-info-item-components/' +
            'advent-calendar-overlay/raster-advent-portrait.svg'),
    'ramadan_landscape': Utils.url(
            './assets/img/additional-info-item-components/' +
            'advent-calendar-overlay/raster-ramadan-landscape.svg'),
    'ramadan_portrait': Utils.url(
            './assets/img/additional-info-item-components/' +
            'advent-calendar-overlay/raster-ramadan-portrait.svg'),
  };

  public removeComponent: () => void;
  public SMASOConfig: ProductConfig|undefined;

  private templateChangedSubscription:
      AsyncEventEmitterSubscriber<TemplateConfig>;
  private rootDocument: Document = document;

  constructor (
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(StageService) private stageService: StageService,
      @Inject(ProductService) private productService: ProductService)
  {
    this.templateChangedSubscription =
        this.designStepService.templateChanged.subscribe(
            async (templateConfig) => {
              this.removeOverlay();
              this.removeComponent();
            });
  }

  public ngOnDestroy(): void
  {
    this.removeOverlay();
    this.designStepService.templateChanged.unsubscribe(
        this.templateChangedSubscription);
  }

  public async initComponent(
      additionalInfoItem: AdditionalInfoItemConfig,
      rootDocument: Document): Promise<void>
  {
    this.rootDocument = rootDocument;
    this.createOverlay();
  }

  private createOverlay(): void
  {
    const stage = this.rootDocument.querySelector('.stage-svg-container');
    const stageConfig = this.stageService.getCurrentStageState().stageConfig;

    const img = document.createElement('img');
    img.classList.add('advent-calendar-overlay');
    if (stageConfig.rotation === 0) {
      img.src = AdventCalendarOverlayComponent.OVERLAY_IMAGE[
          this.getTopic() + '_landscape'];
    }
    else {
      img.src = AdventCalendarOverlayComponent.OVERLAY_IMAGE[
          this.getTopic() + '_portrait'];
    }
    stage.appendChild(img);
  }

  private removeOverlay(): void
  {
    const img = this.rootDocument.querySelector('.advent-calendar-overlay');
    if (img) {
      img.remove();
    }
  }

  private getTopic(): string
  {
    const match = this.productService.getCurrentProduct().id.match(
        /1000-([a-z]+)-calendar$/);
    return match[1];
  }
}
